import { useQuery } from 'react-query';
import queryGetSearchContracts from './queries/getSearchContracts';

const actionsSearchContracts = {
    getSearchContracts: (query, enabled = true) => useQuery(queryGetSearchContracts(query, enabled))
};

export default actionsSearchContracts;